// extracted by mini-css-extract-plugin
export default {"container":"uQ-z","title":"vQ-z","link":"wQ-z"};